import { defineComponent as _defineComponent } from 'vue'
import { Icon, Typo } from '@travelata-libs/ui-kit';
    import { BONUS_MILES_TEXT } from '../../lib/filterByBonusMiles';
    import BonusMilesIcon from './BonusMilesIcon.vue';
    import BonusMilesInfo from './BonusMilesInfo.vue';

    enum IconVariant {
        Green = 'green',
        Grey = 'grey',
    }

    enum IconSpacing {
        Small = 'small', // 4px
        Medium = 'medium', // 8px
    }

    interface BonusMilesContentProps {
        iconVariant?: `${IconVariant}`;
        iconSpacing?: `${IconSpacing}`;
        contentClass?: string;
        hideTooltip?: boolean;
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'BonusMilesBadge',
  props: {
    iconVariant: { default: 'green' },
    iconSpacing: { default: 'small' },
    contentClass: { default: '' },
    hideTooltip: { type: Boolean, default: false }
  },
  setup(__props: any) {

    

return { __sfc: true,IconVariant, IconSpacing, Icon, Typo, BONUS_MILES_TEXT, BonusMilesIcon, BonusMilesInfo }
}

})